import { RightSideBarModule } from '@src/slide/application/service/edit-extension/edit-extension-export';
import {
    AuthComponentParams,
    IAuthPluginPC,
} from '@src/slide/application/no-edit/plugins/auth/toc/pc/auth-plugin-pc.interface';

export const MODULE_NAME = 'auth';

/**
 * 权限侧边栏模块
 */
export class AuthRightBarModule extends RightSideBarModule {
    private authPlugin: IAuthPluginPC;

    public constructor(authPlugin: IAuthPluginPC) {
        super();
        this.authPlugin = authPlugin;
    }

    public get name(): string {
        return MODULE_NAME;
    }

    public show(param: AuthComponentParams): void {
        const { invokeFrom = 'Root', showAdvPermissionsCmp, authUpdateCallback, authExpTimeUpdated, onClose  } = param || { };

        this.authPlugin.showModule({
            invokeFrom,
            showAdvPermissionsCmp,
            DOMNode: this.DOMNode,
            authUpdateCallback,
            authExpTimeUpdated,
            onShow: () => {
                this.showWrapper();
            },
            onClose: () => {
                this.hideWrapper();
                onClose?.();
            },
        });
    }
}
